if (!customElements.get('shop-the-look-slider')) {
  class ShopTheLookSlider extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      this.dotsList = this.querySelector('.js-dots-list');
      this.sliderOptions.watchOverflow = false; // Prevent Swiper from locking buttons
      this.sliderOptions.breakpoints = {
        750: {
          slidesPerView: 1,
          spaceBetween: 72
        },
        990: {
          spaceBetween: 100
        },
        1100: {
          spaceBetween: 130
        },
        1200: {
          spaceBetween: 156
        }
      };

      this.initSlider(this.querySelector('.js-slider'));

      // Handle button state after Swiper initialization
      this.slider?.on('init', () => {
        this.updateButtonStates();
      });

      // Trigger initial button state update
      if (this.slider) {
        // Use setTimeout to ensure Swiper is fully initialized
        setTimeout(() => {
          this.updateButtonStates();
        }, 100);
      }

      this.dotsList.addEventListener('click', e => {
        const isBtn = e.target.classList.contains('js-btn');

        if (!isBtn) {
          return;
        }

        e.preventDefault();

        const btn = e.target;
        const isCurrent = btn.classList.contains('is-current');

        if (isCurrent) {
          return;
        }

        const btnIndex = +btn.dataset.index;

        this.updateActiveDot(btn);
        this.slider.slideTo(btnIndex, 300);
      });

      this.slider?.on('slideChange', e => {
        const sliderIndex = e.realIndex;
        const btn = this.dotsList.querySelector(
          `.js-btn[data-index="${sliderIndex}"]`
        );

        this.updateActiveDot(btn);
      });

      // Handle button disabled state on slide change
      this.slider?.on('slideChange', () => {
        this.updateButtonStates();
      });
    }

    updateButtonStates() {
      const prevButton = this.querySelector('.swiper-button--prev');
      const nextButton = this.querySelector('.swiper-button--next');

      if (prevButton) {
        // Remove Swiper's native classes
        prevButton.classList.remove('swiper-button-lock');

        if (this.slider.isBeginning) {
          prevButton.classList.add('button-disabled', 'swiper-button-disabled');
          prevButton.setAttribute('disabled', 'disabled');
        } else {
          prevButton.classList.remove('button-disabled', 'swiper-button-disabled');
          prevButton.removeAttribute('disabled');
        }
      }

      if (nextButton) {
        // Remove Swiper's native lock class
        nextButton.classList.remove('swiper-button-lock');

        if (this.slider.isEnd) {
          nextButton.classList.add('button-disabled', 'swiper-button-disabled');
          nextButton.setAttribute('disabled', 'disabled');
        } else {
          nextButton.classList.remove('button-disabled', 'swiper-button-disabled');
          nextButton.removeAttribute('disabled');
        }
      }
    }

    connectedCallback() { }

    updateActiveDot(btn) {
      const currentBtn = this.dotsList.querySelector(
        '.js-btn.is-current'
      );

      currentBtn.classList.remove('is-current');
      currentBtn.setAttribute('aria-current', false);

      btn.classList.add('is-current');
      btn.setAttribute('aria-current', true);
    }
  }

  customElements.define('shop-the-look-slider', ShopTheLookSlider);
}
